export default __webpack_public_path__ + "static/media/logo-white.d5d2ce6a.png";